import React from 'react'

import { Helmet } from 'react-helmet'

import './sign-up.css'

const SignUp = (props) => {
  return (
    <div className="sign-up-container">
      <Helmet>
        <title>Sign-Up - Super Sizzling Curlew</title>
        <meta property="og:title" content="Sign-Up - Super Sizzling Curlew" />
        <link
          rel="canonical"
          href="https://super-sizzling-curlew-lvmy3i.teleporthq.site/sign-up"
        />
      </Helmet>
    </div>
  )
}

export default SignUp
